import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Capacitor } from '@capacitor/core'
import { loadWebRuntimeConfig } from './lib/runtimeConfig.js'
import './styles.css'

const root = createRoot(document.getElementById('root'))
const isNative = Capacitor.isNativePlatform()
const isPublicLanding = !isNative && window.location.pathname === '/'

if (isPublicLanding) {
  const { default: PublicLandingPage } = await import('./components/PublicLandingPage.jsx')
  root.render(
    <StrictMode>
      <PublicLandingPage />
    </StrictMode>
  )
} else {
  if (!isNative) await loadWebRuntimeConfig()
  const { initialiseErrorMonitoring } = await import('./lib/errorMonitoring.js')
  await initialiseErrorMonitoring().catch(() => false)

  const [
    { default: App },
    { PracticeProvider },
    { CourseProvider },
    { GrowthConsentProvider },
    { AuthProvider },
    { SubscriptionProvider },
    { initialiseAnalytics, trackEvent }
  ] = await Promise.all([
    import('./App.jsx'),
    import('./state/PracticeContext.jsx'),
    import('./state/CourseContext.jsx'),
    import('./state/GrowthConsentContext.jsx'),
    import('./state/AuthContext.jsx'),
    import('./state/SubscriptionContext.jsx'),
    import('./lib/analytics.js')
  ])

  await initialiseAnalytics()
  void trackEvent('app_open', {
    environment: globalThis.__ASK_STOICS_CONFIG__?.appEnvironment || import.meta.env.VITE_APP_ENV || 'local',
    platform: Capacitor.getPlatform()
  })

  root.render(
    <StrictMode>
      <AuthProvider>
        <SubscriptionProvider>
          <GrowthConsentProvider>
            <CourseProvider>
              <PracticeProvider>
                <App />
              </PracticeProvider>
            </CourseProvider>
          </GrowthConsentProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </StrictMode>
  )
}
